import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AuthEventsService } from './auth-events.service';

export function authInitializer(authService: AuthService,
                                authEventsService: AuthEventsService): Observable<boolean> {
    authEventsService.registerEvents();
    return authService.checkAuth();
}
